import { Component, ViewChild, ViewContainerRef } from "@angular/core";
import { FieldWrapper } from "@ngx-formly/core";

@Component({
  selector: "formly-wrapper-row",
  template: `
    <!-- <div class="card">
      <h3 class="card-header">{{ to.label }}</h3>
      <div class="card-body">
        <ng-container #fieldComponent></ng-container>
      </div>
    </div> -->
    <div class="row">
      <ng-container *ngIf="to.label">
        <div class="col col-12">{{ to.label }}</div>
      </ng-container>
      <ng-container #fieldComponent></ng-container>
    </div>
  `,
})
export class RowWrapperComponent extends FieldWrapper {
  @ViewChild("fieldComponent", { read: ViewContainerRef })
  fieldComponent: ViewContainerRef;
}
